import Vue from 'vue';
import store from '@/store';
import resetState from '@/helpers/resetState';
import { ABI } from './ABI';
import { formatData } from '@/constants/commonContent';
import { messages } from '@/constants/messages';
import { Contract } from 'web3-eth-contract';

const FEATURE_NAME = 'CompanyDataFeature';
const FORMAT_DATE = formatData.dateTime;

let from;

async function contract(): Promise<Contract> {
  from = {from: store.getters.getWallet};
  const address = store.getters.getFeatureAddress(FEATURE_NAME);
  return new Promise(resolve => {
    let contract = new window.web3.eth.Contract(ABI, address);
    resolve(contract);
  });
}

const initialState = {
  companyName: 'Korporatio',
  companyAbout: '',
  companyWallet: null,
  companyBalance: 0,
  companyUpdates: {},
  companyUpdateCounter: 0
};

const state = {
  companyName: initialState.companyName,
  companyAbout: initialState.companyAbout,
  companyWallet: initialState.companyWallet,
  companyBalance: initialState.companyBalance,
  companyUpdates: initialState.companyUpdates,
  companyUpdateCounter: initialState.companyUpdateCounter
};

const getters = {
  getCompanyName: state => state.companyName,
  getCompanyAbout: state => state.companyAbout,
  getCompanyWallet: state => state.companyWallet,
  isTreasuryWallet: (state, getters) => getters.getWallet === getters.getCompanyWallet,
  getCompanyBalance: state => state.companyBalance,
  getCompanyUpdate: state => id => state.companyUpdates[id],
  getCompanyUpdates: state => state.companyUpdates,
  getCompanyUpdateCounter: state => state.companyUpdateCounter,
  getCompanyInfo: (state, getters) => ({
    name: getters.getCompanyName,
    about: getters.getCompanyAbout,
    wallet: getters.getCompanyWallet,
    symbol: getters.getCompanyName.substring(0, 1),
    noSymbol: getters.getCompanyName.substring(1)
  })
};

const mutations = {
  resetCompanyDataFeature: state => {
    resetState(state, initialState);
  },
  setCompanyName: (state, item) => {
    state.companyName = item;
  },
  setCompanyAbout: (state, item) => {
    state.companyAbout = item;
  },
  setCompanyWallet: (state, item) => {
    state.companyWallet = item;
  },
  setCompanyBalance: (state, item) => {
    state.companyBalance = item;
  },
  setCompanyUpdateCounter: (state, item) => {
    state.companyUpdateCounter = item;
  },
  setCompanyUpdate: (state, item) => {
    Vue.set(state.companyUpdates, item.id, item);
  }
};

const actions = {
  initCompanyDataFeature({ dispatch, commit }) {
    dispatch('getCompanyInfoDapp');
    dispatch('getCompanyUpdatesDapp');

    //Events
    contract().then(contract => {
      let transactionHash = '0x';
      contract.events.CompanyUpdateEvent().subscribe((err, res) => {
        if (!err && transactionHash !== res.transactionHash) {
          transactionHash = res.transactionHash;
          dispatch('getCompanyUpdatesDapp');
        }
        commit('companyUpdatePending', false);
      });
      contract.events.CompanyInfoEvent().subscribe((err, res) => {
        if (!err && transactionHash !== res.transactionHash) {
          transactionHash = res.transactionHash;
          dispatch('getCompanyInfoDapp').then(res => {
            dispatch('setCompanyLinkExt', res.companyName);
          });
        }
        commit('companyInfoPending', false);
      });
    });
  },
  /**
   * Get company update action
   * @param id {number}
   * @return {Array}
   * @res[0] {string}
   * @res[1] {string}
   * @res[2] {number}
   */
  getCompanyUpdateDapp({ commit }, id) {
    contract().then(contract => {
      let transactionHash = '0x';
      contract.methods.getCompanyUpdate(id)
        .call(from)
        .then(res => {
          if (transactionHash !== res.transactionHash) {
            transactionHash = res.transactionHash;
            commit('setCompanyUpdate', {
              id,
              address: res[0],
              title: res[1],
              date: Vue.moment.unix(res[2]).format(FORMAT_DATE)
            });
          }
        })
        .catch(console.error);
    });
  },

  getCompanyUpdatesDapp({ dispatch }) {
    dispatch('getCompanyUpdateCounterDapp').then(result => {
      for (let i = 0; i < result; i++) {
       // Timeout need timeout to split requests with the Portis provider.
       setTimeout(() => {
         dispatch('getCompanyUpdateDapp', i);
       }, 500)
      }
    });
  },
  /**
   * Counter companies action
   * @return {Promise<number>}
   * @res[0] "company counter" {number}
   */
  getCompanyUpdateCounterDapp({ commit }) {
    return new Promise(resolve => {
      contract().then(contract => {
        contract.methods.getCompanyUpdateCounter()
          .call()
          .then(res => {
            commit('setCompanyUpdateCounter', res);
            resolve(res);
          })
          .catch(console.error);
      });
    });
  },
  /**
   * Get company update action
   * @param data {Object}
   * @param data.text {string}
   * @res[0] {string}
   * @err {Object}
   */
  addCompanyUpdateDapp({ commit }, data) {
    contract().then(contract => {
      // Set method
      contract.methods.addCompanyUpdate(data.text)
        .send(from, (err) => {
          if (err) {
            commit('companyUpdatePending', false);
            Vue.toasted.error(messages.canceled);
          }
        });
    });
  },
  /**
   * Get information about company
   * @param id {number}
   * @return {Promise<Object>}
   * @res[0] "company name" {string}
   * @res[1] "company about " {string}
   * @res[2] "company wallet" {number}
   * @res[3] "company balance" {number}
   */
  getCompanyInfoDapp({ commit }) {
    return new Promise(resolve => {
      contract().then(contract => {
        // Get method
        contract.methods.getCompanyInfo()
          .call()
          .then(res => {
            if (res[0]) {
              console.log(res, 'res!!!!!!!');
              commit('setCompanyName', res[0]);
              commit('setCompanyAbout', res[1]);
            }
            console.log(res, 'res');
            commit('setCompanyWallet', res[2]);
            commit('setCompanyBalance', parseInt(res[3]));
            resolve({ companyName: res[0] });
          })
          .catch(console.error);
      });
    });
  },
  /**
   * Add information about company
   * @param data {Object}
   * @param data.name {string}
   * @param data.about {string}
   */
  addCompanyInfoDapp({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      contract().then(contract => {
        contract.methods.addCompanyInfo(data.name, data.about)
          .send(from, (err) => {
            if (err) {
              reject()
              commit('companyInfoPending', false);
              Vue.toasted.error(messages.canceled);
            }
            resolve()
          });
      });
    })
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
